import RoundTab from "components/RoundTabButtons/RoundTab";
import moment from "moment";
import react, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal, ModalBody } from "reactstrap";

import durationIcon from "../../../assets/img/icons/clock-in-duration.svg";
import tick from "../../../assets/img/onboardingImg/tick-black.svg";
import BackButtonComponent from "../../../components/BackButtonComponent/BackButtonComponent";
import AddMultipleAssigneeDropdown from "../../../components/CustomDropdown/AddMultipleAssigneeDropdown";
import CreateProjectDropdown from "../../../components/DropdownStyle/CreateProjectDropdown";
import ButtonTextLoader from "../../../components/Loaders/ButtonTextLoader";
import ComponentCircleLoader from "../../../components/Loaders/ComponentCircleLoader";
import Select from "../../../components/ReactSelectDropdown";
import { filterOption } from "../../../components/ReactSelectDropdown/ReactSelectDropdown";
import DatePicker from "../../../components/SingleDatePicker/SingleDatePicker";
import { PrimaryButton, WhiteButton } from "../../../styledComponents/buttons";
import {
  TabButton,
  TabButtonContainer,
} from "../../../styledComponents/buttons";
import {
  CardTitle,
  CommonFlex,
  CommonGrid,
  CommonText,
  Container,
  ContentHeader,
  FormAlert,
  InputField,
  InputLabel,
  InputTextArea,
  InputWithLabelSection,
  PageTitle,
} from "../../../styledComponents/common";
import { RedStar } from "../../../styledComponents/members";
import { formatDurationToHoursMinutes } from "../../../utils/helper";
import { checkHtml, checkUrl, validateEmail } from "../../../utils/helper";
import {
  AssigneeSection,
  InputSection,
  TimeRangeSection,
} from "../../Jobs/CreateJob/createTaskStyles";
import { CommDropdownComp } from "../../Tasks/AddAssigneeDropdown";
import TimeRangeComponent from "../../Timesheet/Daily/TimeRangeComponent";
import {
  DurationContainer,
  DurationText,
  MonthDateBox,
  MonthDateContainer,
  RepeatSection,
  ScheduleText,
  ThemeBox,
  ThemesContainer,
  WeekDaysContainer,
  WeekNumberBox,
  WeekdayBox,
} from "../CreateShift/createShiftStyles";
import { RadioButton } from "../DeleteShiftPopup";

const EditShift = ({
  selectedOrganization,
  memberShortListIsLoading,
  detailsIsLoading,
  editIsLoading,
  editAssigneesIsLoading,

  orgMembersShortList,
  shiftDetails,
  editedAssigneeList,
  editCallback,
  jobShortList,
  officesShortList,

  getOrganizationMembersShortList,
  getShiftDetails,
  editShiftAssigneesAdd,
  editShiftAssigneesRemove,
  editShift,

  isOpen,
  toggle,
  selectedStartDate,
  shift,
  onEditChange,
  pricingPopupToggle,
}) => {
  const { t, i18n } = useTranslation();

  const MONTH_GRID_COLUMNS = 7;
  const MONTH_TOTAL_DAYS = 31;
  const LAST_DAY_SPAN_COLUMNS =
    (MONTH_GRID_COLUMNS - (MONTH_TOTAL_DAYS % MONTH_GRID_COLUMNS)) %
      MONTH_GRID_COLUMNS || MONTH_GRID_COLUMNS;

  const [title, setTitle] = useState("");
  const [selectedOffice, setSelectedOffice] = useState(null);
  const [officeOptions, setOfficeOptions] = useState([]);
  const [selectedAssignees, setSelectedAssignees] = useState([]);
  const [startDate, setStartDate] = useState(moment(new Date()));
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [isRepeat, setIsRepeat] = useState(false);
  const [selectedRepeatType, setSelectedRepeatType] = useState("");
  const [defaultRepeatOptions, setDefaultRepeatOptions] = useState([]);
  const [interval, setInterval] = useState(1);
  const [activeDays, setActiveDays] = useState({
    monday: false,
    tuesday: false,
    wednesday: false,
    thursday: false,
    friday: false,
    saturday: false,
    sunday: false,
  });
  const weekParse = {
    monday: 0,
    tuesday: 1,
    wednesday: 2,
    thursday: 3,
    friday: 4,
    saturday: 5,
    sunday: 6,
  };
  const weekArray = [
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
    "sunday",
  ];
  const [isWeekViewOfMonth, setIsWeekViewOfMonth] = useState(false);
  const [activeMonthDates, setActiveMonthDates] = useState({});
  const [activeMonthDays, setActiveMonthDays] = useState({});
  const [scheduleDescription, setScheduleDescription] = useState("");
  const [endDate, setEndDate] = useState(null);
  const [description, setDescription] = useState("");
  const [themeColor, setThemeColor] = useState("");
  const [editType, setEditType] = useState("");
  const [saveErrors, setSaveErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const weekDays = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
  const dateText = {
    1: "1st",
    2: "2nd",
    3: "3rd",
    21: "21st",
    22: "22nd",
    23: "23rd",
    31: "31st",
    "Last Day": "last",
  };

  useEffect(() => {
    if (
      selectedOrganization &&
      selectedOrganization.id &&
      isOpen &&
      shift &&
      shift.id
    ) {
      getOrganizationMembersShortList({
        organization_id: selectedOrganization.id,
        office_id: null,
      });
      getShiftDetails({
        organization_id: selectedOrganization.id,
        shift_id: shift.id,
      });

      // Setup default repeat options
      let defaultOptions = [];
      defaultOptions.push({
        label: `Daily`,
        value: "daily",
      });
      defaultOptions.push({
        label: `Custom Weekly...`,
        value: "custom_weekly",
      });
      defaultOptions.push({
        label: `Custom Monthly...`,
        value: "custom_monthly",
      });
      setDefaultRepeatOptions(defaultOptions);

      // Setup month dates and days
      let tempActiveMonthDates = {};
      for (let i = 1; i <= 31; i++) {
        tempActiveMonthDates[String(i)] = false;
      }
      tempActiveMonthDates["Last Day"] = false;
      setActiveMonthDates(tempActiveMonthDates);

      let tempActiveMonthDays = {};
      for (let i = 0; i <= 27; i++) {
        tempActiveMonthDays[i] = false;
      }
      setActiveMonthDays(tempActiveMonthDays);
    }
    return () => {
      clearState();
    };
  }, [selectedOrganization, isOpen]);

  useEffect(() => {
    if (officesShortList && officesShortList.length > 0) {
      let newArr = [];
      officesShortList.forEach((office, i) => {
        newArr.push({
          label: office.name,
          value: office.id,
        });
      });
      setOfficeOptions(newArr);
    }
  }, [officesShortList]);

  useEffect(() => {
    if (shiftDetails && Object.keys(shiftDetails).length > 0) {
      // Set title
      if (shiftDetails.name) {
        setTitle(shiftDetails.name);
      }

      // Set office (read-only)
      if (shiftDetails.office && shiftDetails.office.id) {
        setSelectedOffice({
          label: shiftDetails.office.name,
          value: shiftDetails.office.id,
        });
      }

      // Set description
      if (shiftDetails.description) {
        setDescription(shiftDetails.description);
      }
      if (shiftDetails.assignees && shiftDetails.assignees.length > 0) {
        let newArr = [];
        shiftDetails.assignees.forEach(assignee => {
          newArr.push({
            ...assignee,
            name:
              `${assignee.first_name} ${assignee.last_name}`.trim() ||
              assignee.first_name,
          });
        });
        setSelectedAssignees(newArr);
      }
      if (shiftDetails.start_time) {
        setStartDate(moment(shiftDetails.start_time));
        setStartTime(moment(shiftDetails.start_time).format("HH:mm:ss"));
      }

      if (shiftDetails.end_time) {
        setEndTime(moment(shiftDetails.end_time).format("HH:mm:ss"));
      }
      if (shiftDetails.theme_color) {
        setThemeColor(shiftDetails.theme_color);
      }
      // Handle recurring shift data
      if (shiftDetails.recurring) {
        setIsRepeat(true);
        setInterval(parseInt(shiftDetails.interval) || 1);

        if (shiftDetails.required_end_date) {
          setEndDate(moment(shiftDetails.required_end_date));
        }

        // Set schedule type and active days/dates
        if (shiftDetails.schedule_type === "daily") {
          setSelectedRepeatType({
            value: "daily",
            label: "Daily",
          });
        } else if (
          shiftDetails.schedule_type === "weekly" &&
          shiftDetails.days_of_week &&
          shiftDetails.days_of_week.length > 0
        ) {
          setSelectedRepeatType({
            value: "custom_weekly",
            label: `Weekly`,
          });

          let tempActiveDays = { ...activeDays };
          shiftDetails.days_of_week.forEach(day => {
            const dayKey = weekArray[day];
            if (dayKey) {
              tempActiveDays[dayKey] = true;
            }
          });
          setActiveDays(tempActiveDays);
        } else if (shiftDetails.schedule_type === "monthly") {
          setSelectedRepeatType({
            value: "custom_monthly",
            label: "Custom Monthly",
          });

          if (!shiftDetails.is_weekdays_of_month) {
            setIsWeekViewOfMonth(false);
            let tempActiveMonthDates = {};
            for (let i = 1; i <= 31; i++) {
              tempActiveMonthDates[String(i)] = false;
            }
            tempActiveMonthDates["Last Day"] = false;

            if (shiftDetails.days_of_month) {
              shiftDetails.days_of_month.forEach(day => {
                tempActiveMonthDates[String(day)] = true;
              });
            }
            if (shiftDetails.is_last_day_month) {
              tempActiveMonthDates["Last Day"] = true;
            }
            setActiveMonthDates(tempActiveMonthDates);
          } else {
            setIsWeekViewOfMonth(true);
            let tempActiveMonthDays = {};
            for (let i = 0; i <= 27; i++) {
              tempActiveMonthDays[i] = false;
            }
            if (shiftDetails.weekdays_of_month) {
              shiftDetails.weekdays_of_month.forEach(day => {
                tempActiveMonthDays[day] = true;
              });
            }
            setActiveMonthDays(tempActiveMonthDays);
          }
        }
      }
    }
  }, [shiftDetails]);

  useEffect(() => {
    if (
      interval &&
      interval > 0 &&
      selectedRepeatType &&
      selectedRepeatType.value
    ) {
      let typeText = "";
      let activeDaysText = "";
      let finalText = "";

      if (
        selectedRepeatType.value === "weekly" ||
        selectedRepeatType.value === "biweekly" ||
        selectedRepeatType.value === "monthly"
      ) {
        finalText = selectedRepeatType.label;
        setScheduleDescription(finalText);
      } else if (selectedRepeatType.value === "daily") {
        interval === 1
          ? (finalText = "Daily ")
          : (finalText = `Every ${interval} days `);
        setScheduleDescription(finalText);
      } else if (selectedRepeatType.value === "custom_weekly") {
        interval === 1
          ? (typeText = "Weekly ")
          : (typeText = `Every ${interval} weeks `);
        let tempActiveDaysArray = [];
        for (let key in activeDays) {
          if (activeDays[key]) {
            tempActiveDaysArray.push(
              key.charAt(0).toUpperCase() + key.slice(1),
            );
          }
        }
        if (tempActiveDaysArray.length === 1) {
          activeDaysText = `on ${tempActiveDaysArray[0]}.`;
        } else if (tempActiveDaysArray.length > 1) {
          let lastDay = tempActiveDaysArray.pop();
          activeDaysText = `on ${tempActiveDaysArray.join(
            ", ",
          )} and ${lastDay}.`;
        }
        finalText = typeText + activeDaysText;
        setScheduleDescription(finalText);
      } else if (selectedRepeatType.value === "custom_monthly") {
        activeDaysText = "on the ";
        interval === 1
          ? (typeText = "Monthly ")
          : (typeText = `Every ${interval} months `);
        if (isWeekViewOfMonth) {
          for (let i = 0; i < 7; i++) {
            for (let n = 0; n < 4; n++) {
              if (activeMonthDays[n * 7 + i]) {
                activeDaysText += `${findDateText(n + 1)} ${
                  Object.keys(weekParse)[i].charAt(0).toUpperCase() +
                  Object.keys(weekParse)[i].slice(1)
                } and `;
              }
            }
          }
          activeDaysText = activeDaysText.slice(0, -5) + ".";
          finalText = typeText + activeDaysText;
          setScheduleDescription(finalText);
        } else {
          let tempActiveDaysArray = [];
          for (let key in activeMonthDates) {
            if (activeMonthDates[key]) {
              tempActiveDaysArray.push(findDateText(key));
            }
          }
          if (tempActiveDaysArray.length === 1) {
            activeDaysText = `on ${tempActiveDaysArray[0]} day of the month.`;
          } else if (tempActiveDaysArray.length > 1) {
            let lastDay = tempActiveDaysArray.pop();
            activeDaysText = `on ${tempActiveDaysArray.join(
              ", ",
            )} and ${lastDay} day of the month.`;
          }
          finalText = typeText + activeDaysText;
          setScheduleDescription(finalText);
        }
      }
    }
  }, [
    selectedRepeatType,
    interval,
    activeDays,
    isWeekViewOfMonth,
    activeMonthDates,
    activeMonthDays,
  ]);

  const handleAssignOrRemoveMember = (user, action) => {
    if (user && user.id) {
      let errors = { ...saveErrors };
      delete errors["selectedAssignees"];
      setSaveErrors(errors);
      let newArr = [...selectedAssignees];
      if (action === "remove") {
        newArr = newArr.filter(member => member.id !== user.id);
      } else {
        newArr.push(user);
      }
      setSelectedAssignees(newArr);
    }
  };

  const handleAssignMember = user => {
    handleAssignOrRemoveMember(user, "assign");
    if (user && user.id) {
      editShiftAssigneesAdd({
        organization_id: selectedOrganization.id,
        shift_id: shiftDetails.id,
        user_id: user.id,
      });
    }
  };

  const handleRemoveMember = user => {
    handleAssignOrRemoveMember(user, "remove");
    if (user && user.id) {
      editShiftAssigneesRemove({
        organization_id: selectedOrganization.id,
        shift_id: shiftDetails.id,
        user_id: user.id,
      });
    }
  };

  const onStartDateSelect = date => {
    setStartDate(date);
  };

  const handleStartTime = time => {
    if (time) {
      let errors = { ...saveErrors };
      delete errors["timeDifference"];
      setSaveErrors(errors);
      const start_time = time.replace(/ /g, "");
      setStartTime(moment(start_time, "h:mmA").format("HH:mm:ss"));
    } else {
      setStartTime("");
    }
  };
  const handleEndTime = time => {
    if (time) {
      let errors = { ...saveErrors };
      delete errors["timeDifference"];
      setSaveErrors(errors);
      const end_time = time.replace(/ /g, "");
      setEndTime(moment(end_time, "h:mmA").format("HH:mm:ss"));
    } else {
      setEndTime("");
    }
  };

  const onRepeatTypeChange = e => {
    let errors = { ...saveErrors };
    delete errors["selectedRepeatType"];
    setSaveErrors(errors);
    let tempActiveDays = {
      monday: false,
      tuesday: false,
      wednesday: false,
      thursday: false,
      friday: false,
      saturday: false,
      sunday: false,
    };

    switch (e.value) {
      case "custom_weekly":
        tempActiveDays[startDate.format("dddd").toLocaleLowerCase()] = true;
        setActiveDays(tempActiveDays);
        setInterval(parseInt(1));
        break;
      case "biweekly":
        tempActiveDays[startDate.format("dddd").toLocaleLowerCase()] = true;
        setActiveDays(tempActiveDays);
        setInterval(parseInt(2));
        break;
      default:
    }
    setSelectedRepeatType(e);
  };

  const onEndDateSelect = date => {
    let errors = { ...saveErrors };
    delete errors["endDate"];
    setSaveErrors(errors);
    setEndDate(date);
  };

  const onActiveDaysSelect = day => {
    let errors = { ...saveErrors };
    delete errors["activeDays"];
    setSaveErrors(errors);
    let tempActiveDays = { ...activeDays };
    tempActiveDays[day] = !tempActiveDays[day];
    setActiveDays(tempActiveDays);
  };

  const handleThemeColor = color => {
    setThemeColor(color);
  };

  const onTitleChange = e => {
    let errors = { ...saveErrors };
    delete errors["title"];
    setSaveErrors(errors);
    setTitle(e.target.value);
  };

  const onDescriptionChange = e => {
    let errors = { ...saveErrors };
    delete errors["description"];
    setSaveErrors(errors);
    setDescription(e.target.value);
  };

  const onIntervalChange = value => {
    let errors = { ...saveErrors };
    delete errors["interval"];
    setSaveErrors(errors);
    setInterval(parseInt(value));
  };

  const onMonthDateSelect = date => {
    let errors = { ...saveErrors };
    delete errors["activeMonthDates"];
    setSaveErrors(errors);
    let tempActiveMonthDates = { ...activeMonthDates };
    tempActiveMonthDates[date] = !tempActiveMonthDates[date];
    setActiveMonthDates(tempActiveMonthDates);
  };

  const onMonthDaySelect = day => {
    let errors = { ...saveErrors };
    delete errors["activeMonthDays"];
    setSaveErrors(errors);
    let tempActiveMonthDays = { ...activeMonthDays };
    tempActiveMonthDays[day] = !tempActiveMonthDays[day];
    setActiveMonthDays(tempActiveMonthDays);
  };

  const findDateText = date => {
    if (dateText[date]) {
      return dateText[date];
    } else {
      return `${date}th`;
    }
  };

  const handleFinish = () => {
    toggle();
  };

  const clearState = () => {
    setTitle("");
    setSelectedOffice(null);
    setOfficeOptions([]);
    setSelectedAssignees([]);
    setStartDate(moment(new Date()));
    setStartTime("");
    setEndTime("");
    setIsRepeat(false);
    setSelectedRepeatType("");
    setDefaultRepeatOptions([]);
    setInterval(1);
    setActiveDays({
      monday: false,
      tuesday: false,
      wednesday: false,
      thursday: false,
      friday: false,
      saturday: false,
      sunday: false,
    });
    setIsWeekViewOfMonth(false);
    setActiveMonthDates({});
    setActiveMonthDays({});
    setScheduleDescription("");
    setEndDate(null);
    setDescription("");
    setThemeColor("");
    setEditType("");
    setSaveErrors({});
    setIsSubmitted(false);
  };

  const onChangeEditType = type => {
    setEditType(type);
    if (type === "future") {
      setIsRepeat(true);
    } else {
      setIsRepeat(false);
    }
  };

  const checkPlan = () => {
    if (
      isRepeat &&
      selectedOrganization &&
      selectedOrganization.plan &&
      selectedOrganization.plan.name === "Free"
    ) {
      toggle();
      pricingPopupToggle();
      return false;
    } else {
      return true;
    }
  };

  const handleSave = () => {
    if (
      editType &&
      checkError() &&
      checkPlan() &&
      selectedOrganization &&
      selectedOrganization.id
    ) {
      let assigneeIds = [];
      if (selectedAssignees && selectedAssignees.length > 0) {
        selectedAssignees.forEach(element => {
          assigneeIds.push(element.id);
        });
      }

      let payload = {
        organization_id: selectedOrganization.id,
        shift_id: shiftDetails.id,
        name: title,
        assignees: assigneeIds,
        required_start_date: moment(startDate).format("YYYY-MM-DDTHH:mm:ss"),
        start_time: moment(
          startDate.format("YYYY-MM-DD") + " " + startTime,
          "YYYY-MM-DD h:mmA",
        ).format("YYYY-MM-DDTHH:mm:ss"),
        end_time: moment(
          startDate.format("YYYY-MM-DD") + " " + endTime,
          "YYYY-MM-DD h:mmA",
        ).format("YYYY-MM-DDTHH:mm:ss"),
        bulk: editType === "future" ? true : false,
      };

      if (description) {
        payload.description = description;
      }

      if (themeColor) {
        payload.theme_color = themeColor;
      }

      // Handle recurring schedule for future edits
      if (editType === "future") {
        payload.recurring = true;
        if (
          selectedRepeatType.value === "biweekly" ||
          selectedRepeatType.value === "custom_weekly"
        ) {
          payload.schedule_type = "weekly";
        } else if (selectedRepeatType.value === "custom_monthly") {
          payload.schedule_type = "monthly";
        } else {
          payload.schedule_type = selectedRepeatType.value;
        }
        payload.interval = interval;
        payload.required_end_date = endDate.format("YYYY-MM-DDTHH:mm:ss");

        if (
          selectedRepeatType.value === "weekly" ||
          selectedRepeatType.value === "biweekly" ||
          selectedRepeatType.value === "custom_weekly"
        ) {
          let tempActiveDaysArray = [];
          for (let key in activeDays) {
            if (activeDays[key]) {
              tempActiveDaysArray.push(weekParse[key]);
            }
          }
          payload.days_of_week = tempActiveDaysArray;
        } else if (
          selectedRepeatType.value === "monthly" ||
          (selectedRepeatType.value === "custom_monthly" && !isWeekViewOfMonth)
        ) {
          let tempMonthDatesArray = [];
          for (let i = 1; i <= 31; i++) {
            if (activeMonthDates[String(i)]) {
              tempMonthDatesArray.push(i);
            }
          }
          payload.days_of_month = tempMonthDatesArray;
          if (activeMonthDates["Last Day"]) {
            payload.is_last_day_month = true;
          }
          payload.is_weekdays_of_month = false;
        } else if (
          selectedRepeatType.value === "custom_monthly" &&
          isWeekViewOfMonth
        ) {
          let tempMonthDaysArray = [];
          for (let i = 0; i <= 27; i++) {
            if (activeMonthDays[i]) {
              tempMonthDaysArray.push(i);
            }
          }
          payload.weekdays_of_month = tempMonthDaysArray;
          payload.is_weekdays_of_month = true;
        }
      } else {
        // Single edit - keep original recurring status
        payload.recurring = shiftDetails.recurring || false;
        if (!payload.recurring) {
          payload.required_end_date = moment(startDate).format(
            "YYYY-MM-DDTHH:mm:ss",
          );
        }
      }

      editShift(payload);
      setIsSubmitted(true);
      onEditChange(true);
    }
  };

  const checkError = () => {
    let saveErrors = {};
    let formIsValid = true;

    if (!title.trim()) {
      formIsValid = false;
      saveErrors["title"] = "Title is required";
    } else if (checkUrl(title)) {
      formIsValid = false;
      saveErrors["title"] = "Title can not contain url.";
    } else if (checkHtml(title)) {
      formIsValid = false;
      saveErrors["title"] = "Invalid Title";
    } else if (title.length > 255) {
      formIsValid = false;
      saveErrors["title"] = "Please enter title within 255 characters";
    }

    if (checkUrl(description)) {
      formIsValid = false;
      saveErrors["description"] = "Description can not contain url.";
    } else if (checkHtml(description)) {
      formIsValid = false;
      saveErrors["description"] = "Invalid shift description";
    } else if (description.length > 512) {
      formIsValid = false;
      saveErrors["description"] =
        "Please enter description within 512 characters";
    }

    if (selectedAssignees.length === 0) {
      formIsValid = false;
      saveErrors["selectedAssignees"] = "Assignee is required";
    }
    if (!startDate) {
      formIsValid = false;
    }
    if (!startTime || !endTime) {
      formIsValid = false;
    }
    if (
      moment(startDate.format("YYYY-MM-DD") + " " + endTime).diff(
        moment(startDate.format("YYYY-MM-DD") + " " + startTime),
      ) < 1
    ) {
      formIsValid = false;
      saveErrors["timeDifference"] = "End time must be after start time";
    } else if (
      moment(startDate.format("YYYY-MM-DD") + " " + endTime).diff(
        moment(startDate.format("YYYY-MM-DD") + " " + startTime),
      ) < 1800000
    ) {
      formIsValid = false;
      saveErrors["timeDifference"] =
        "Minmium 30 minutes time difference required";
    }

    if (editType === "future") {
      if (!selectedRepeatType) {
        formIsValid = false;
        saveErrors["selectedRepeatType"] = "Shift repeat type must be set";
      }
      if (!endDate) {
        formIsValid = false;
        saveErrors["endDate"] = "Ending date is must";
      }
      if (selectedRepeatType && selectedRepeatType.value === "custom_weekly") {
        let haveActiveDays = false;
        Object.keys(activeDays).forEach(key => {
          if (activeDays[key] === true) {
            haveActiveDays = true;
          }
        });
        if (!haveActiveDays) {
          formIsValid = false;
          saveErrors["activeDays"] = "At least one day needs to be selected";
        }
      }
      if (selectedRepeatType && interval < 1) {
        formIsValid = false;
        saveErrors["interval"] = "Interval is required";
      } else if (
        selectedRepeatType &&
        ((selectedRepeatType.value === "daily" && interval > 150) ||
          (selectedRepeatType.value === "custom_weekly" && interval > 25) ||
          (selectedRepeatType.value === "custom_monthly" && interval > 10))
      ) {
        formIsValid = false;
        saveErrors["interval"] = `Interval maximum limit is ${
          selectedRepeatType.value === "daily"
            ? `150 for daily`
            : selectedRepeatType.value === "custom_weekly"
            ? `25 for weekly`
            : selectedRepeatType.value === "custom_monthly" && `10 for monthly`
        } schedule`;
      }
      if (
        selectedRepeatType &&
        selectedRepeatType.value === "custom_monthly" &&
        !isWeekViewOfMonth
      ) {
        let haveActiveDays = false;
        Object.keys(activeMonthDates).forEach(key => {
          if (activeMonthDates[key] === true) {
            haveActiveDays = true;
          }
        });
        if (!haveActiveDays) {
          formIsValid = false;
          saveErrors["activeMonthDates"] =
            "At least one day needs to be selected";
        }
      }
      if (
        selectedRepeatType &&
        selectedRepeatType.value === "custom_monthly" &&
        isWeekViewOfMonth
      ) {
        let haveActiveDays = false;
        Object.keys(activeMonthDays).forEach(key => {
          if (activeMonthDays[key] === true) {
            haveActiveDays = true;
          }
        });
        if (!haveActiveDays) {
          formIsValid = false;
          saveErrors["activeMonthDays"] =
            "At least one day needs to be selected";
        }
      }
    }
    setSaveErrors(saveErrors);
    return formIsValid;
  };

  const ThemeColorComp = ({ color }) => (
    <ThemeBox color={color} onClick={() => handleThemeColor(color)}>
      {themeColor === color && <img src={tick} alt="" width="18px" />}
    </ThemeBox>
  );

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      style={{ maxWidth: `660px` }}
      backdrop="static"
    >
      <ModalBody style={{ padding: `40px`, minHeight: `800px` }}>
        <CardTitle>{t("edit_shift")}</CardTitle>
        {detailsIsLoading ? (
          <ComponentCircleLoader />
        ) : (
          <>
            <InputSection gap="20px 5%" style={{ marginTop: `20px` }}>
              <InputWithLabelSection style={{ maxWidth: `260px` }}>
                <InputLabel>
                  {t("select_team")} <RedStar>*</RedStar>
                </InputLabel>
                <Select
                  isSearchable
                  value={selectedOffice}
                  options={officeOptions}
                  placeholder="Select Team"
                  isDisabled={true}
                  styles={CreateProjectDropdown()}
                  filterOption={filterOption}
                />
              </InputWithLabelSection>

              <InputWithLabelSection style={{ gridColumn: `1 / span 2` }}>
                <InputLabel>
                  {t("title")} <RedStar>*</RedStar>
                </InputLabel>
                <InputField
                  height="40px"
                  type="text"
                  value={title}
                  onChange={e => onTitleChange(e)}
                  onWheel={e => e.target.blur()}
                  style={
                    saveErrors &&
                    saveErrors[`title`] && {
                      border: `1px solid #fe5969`,
                      backgroundColor: `rgba(252, 87, 104, 0.05)`,
                    }
                  }
                />
                {saveErrors &&
                  saveErrors["title"] !== undefined &&
                  saveErrors["title"] && (
                    <FormAlert>{saveErrors["title"]}</FormAlert>
                  )}
              </InputWithLabelSection>

              <InputWithLabelSection style={{ gridColumn: `1 / span 2` }}>
                <InputLabel>{t("description")}</InputLabel>
                <InputTextArea
                  text="Description"
                  cols="35"
                  rows="4"
                  value={description}
                  placeholder={t("type_description_here")}
                  onChange={e => onDescriptionChange(e)}
                  height="auto"
                  style={
                    saveErrors &&
                    saveErrors[`description`] && {
                      border: `1px solid #fe5969`,
                      backgroundColor: `rgba(252, 87, 104, 0.05)`,
                    }
                  }
                ></InputTextArea>
                {saveErrors &&
                  saveErrors["description"] &&
                  saveErrors["description"] !== undefined && (
                    <FormAlert>{saveErrors["description"]}</FormAlert>
                  )}
              </InputWithLabelSection>

              <AssigneeSection>
                <InputLabel>
                  {t("assignee")} <RedStar>*</RedStar>
                </InputLabel>

                <AddMultipleAssigneeDropdown
                  numberOfVisibleMembers={5}
                  isLoading={memberShortListIsLoading}
                  assigneesList={selectedAssignees}
                  membersList={orgMembersShortList}
                  handleAssign={handleAssignMember}
                  handleRemove={handleRemoveMember}
                />

                {saveErrors && saveErrors["selectedAssignees"] && (
                  <FormAlert>{saveErrors["selectedAssignees"]}</FormAlert>
                )}
              </AssigneeSection>

              <InputWithLabelSection style={{ gridColumn: `1 / span 2` }}>
                <CommonText fontWeight="600" fontSize="18px">
                  {t("choose_edit_type")}
                </CommonText>
                <CommonFlex gap="4px" flexDirection="column">
                  {/* <CommonFlex
                    gap="10px"
                    style={{ cursor: `pointer` }}
                    onClick={() => onChangeEditType("single")}
                  > */}
                  <RoundTab
                    onClick={() => onChangeEditType("single")}
                    selected={editType === "single"}
                    text="Only edit this shift"
                  />
                  {/* </CommonFlex> */}
                  {/* <CommonFlex
                    gap="10px"
                    style={{ cursor: `pointer` }}
                    onClick={() => onChangeEditType("future")}
                  > */}
                  <RoundTab
                    onClick={() => onChangeEditType("future")}
                    selected={editType === "future"}
                    text={
                      shiftDetails?.recurring
                        ? "Edit this shift and all future shifts"
                        : "Make this shift recurring"
                    }
                  />
                  {/* </CommonFlex> */}
                </CommonFlex>
              </InputWithLabelSection>

              {editType !== "" && (
                <>
                  <InputWithLabelSection>
                    <InputLabel>
                      {isRepeat ? (
                        <>{t("shift_start_date")}</>
                      ) : (
                        <>{t("select_date")}</>
                      )}{" "}
                      <RedStar>*</RedStar>
                    </InputLabel>
                    <DatePicker
                      id="editShiftStartDate"
                      date={startDate ? startDate : null}
                      onDateChange={onStartDateSelect}
                      dateDisplayFormat="DD/MM/YYYY"
                      placeholder="Select Date"
                    />
                  </InputWithLabelSection>
                  <InputWithLabelSection>
                    <TimeRangeSection>
                      <InputLabel>
                        {t("start_time")}
                        <RedStar> *</RedStar>
                      </InputLabel>
                      <InputLabel>
                        {t("end_time")}
                        <RedStar> *</RedStar>
                      </InputLabel>
                    </TimeRangeSection>
                    <TimeRangeComponent
                      setStartTime={handleStartTime}
                      setEndTime={handleEndTime}
                      initialStartTime={
                        shiftDetails &&
                        shiftDetails.start_time &&
                        moment(shiftDetails.start_time).format("HH:mm")
                      }
                      initialEndTime={
                        shiftDetails &&
                        shiftDetails.end_time &&
                        moment(shiftDetails.end_time).format("HH:mm")
                      }
                      startTimeError={
                        saveErrors &&
                        saveErrors["timeDifference"] !== undefined &&
                        saveErrors["timeDifference"] &&
                        saveErrors["timeDifference"]
                      }
                      endTimeError={
                        saveErrors &&
                        saveErrors["timeDifference"] !== undefined &&
                        saveErrors["timeDifference"] &&
                        saveErrors["timeDifference"]
                      }
                    />
                    {saveErrors &&
                      saveErrors["timeDifference"] !== undefined &&
                      saveErrors["timeDifference"] && (
                        <FormAlert>{saveErrors["timeDifference"]}</FormAlert>
                      )}
                    <DurationContainer>
                      <DurationText>
                        <img
                          src={durationIcon}
                          alt="duration icon"
                          width="15px"
                        />{" "}
                        {t("shift_duration")}:{" "}
                        {formatDurationToHoursMinutes(
                          moment(
                            startDate.format("YYYY-MM-DD") + " " + endTime,
                          ).diff(
                            moment(
                              startDate.format("YYYY-MM-DD") + " " + startTime,
                            ),
                          ) / 1000,
                        )}
                      </DurationText>
                    </DurationContainer>
                  </InputWithLabelSection>
                </>
              )}
            </InputSection>
            <div style={{ gridColumn: `1 / span 2` }}>
              {editType === "future" && (
                <RepeatSection editType={editType}>
                  <InputWithLabelSection>
                    <InputLabel>
                      {t("repeats")} <RedStar>*</RedStar>
                    </InputLabel>
                    <Select
                      value={selectedRepeatType}
                      options={defaultRepeatOptions}
                      placeholder={t("select_type")}
                      onChange={e => {
                        onRepeatTypeChange(e);
                      }}
                      styles={CreateProjectDropdown({
                        error: saveErrors["selectedRepeatType"],
                      })}
                    />

                    {saveErrors &&
                      saveErrors["selectedRepeatType"] !== undefined &&
                      saveErrors["selectedRepeatType"] && (
                        <FormAlert>
                          {saveErrors["selectedRepeatType"]}
                        </FormAlert>
                      )}
                  </InputWithLabelSection>

                  {selectedRepeatType &&
                    (selectedRepeatType.value === "daily" ||
                      selectedRepeatType.value === "custom_weekly" ||
                      selectedRepeatType.value === "custom_monthly") && (
                      <InputWithLabelSection>
                        <CommonFlex gap="10px">
                          <InputLabel>Every</InputLabel>
                          <InputField
                            height="40px"
                            width="70px"
                            type="number"
                            value={interval}
                            onChange={e => onIntervalChange(e.target.value)}
                            onWheel={e => e.target.blur()}
                            style={
                              saveErrors &&
                              saveErrors[`interval`] && {
                                border: `1px solid #fe5969`,
                                backgroundColor: `rgba(252, 87, 104, 0.05)`,
                              }
                            }
                          />
                          <InputLabel>
                            {selectedRepeatType &&
                            selectedRepeatType.value === "daily"
                              ? "day(s)"
                              : selectedRepeatType.value === "custom_weekly"
                              ? "week(s)"
                              : selectedRepeatType.value === "custom_monthly" &&
                                "month(s)"}
                          </InputLabel>
                        </CommonFlex>
                        {saveErrors &&
                          saveErrors["interval"] !== undefined &&
                          saveErrors["interval"] && (
                            <FormAlert>{saveErrors["interval"]}</FormAlert>
                          )}
                      </InputWithLabelSection>
                    )}

                  {selectedRepeatType &&
                    selectedRepeatType.value === "custom_weekly" && (
                      <>
                        <InputWithLabelSection>
                          <InputLabel
                            error={
                              saveErrors &&
                              saveErrors["activeDays"] !== undefined &&
                              saveErrors["activeDays"] &&
                              saveErrors["activeDays"]
                            }
                          >
                            {t("on_these_days")} <RedStar>*</RedStar>
                          </InputLabel>
                          <WeekDaysContainer>
                            <WeekdayBox
                              active={activeDays.monday}
                              onClick={() => onActiveDaysSelect("monday")}
                            >
                              {t("mon")}
                            </WeekdayBox>
                            <WeekdayBox
                              active={activeDays.tuesday}
                              onClick={() => onActiveDaysSelect("tuesday")}
                            >
                              {t("tue")}
                            </WeekdayBox>
                            <WeekdayBox
                              active={activeDays.wednesday}
                              onClick={() => onActiveDaysSelect("wednesday")}
                            >
                              {t("wed")}
                            </WeekdayBox>
                            <WeekdayBox
                              active={activeDays.thursday}
                              onClick={() => onActiveDaysSelect("thursday")}
                            >
                              {t("thu")}
                            </WeekdayBox>
                            <WeekdayBox
                              active={activeDays.friday}
                              onClick={() => onActiveDaysSelect("friday")}
                            >
                              {t("fri")}
                            </WeekdayBox>
                            <WeekdayBox
                              active={activeDays.saturday}
                              onClick={() => onActiveDaysSelect("saturday")}
                            >
                              {t("sat")}
                            </WeekdayBox>
                            <WeekdayBox
                              active={activeDays.sunday}
                              onClick={() => onActiveDaysSelect("sunday")}
                            >
                              {t("sun")}
                            </WeekdayBox>
                          </WeekDaysContainer>
                        </InputWithLabelSection>
                        {saveErrors &&
                          saveErrors["activeDays"] !== undefined &&
                          saveErrors["activeDays"] && (
                            <FormAlert>{saveErrors["activeDays"]}</FormAlert>
                          )}
                      </>
                    )}

                  {selectedRepeatType &&
                    selectedRepeatType.value === "custom_monthly" && (
                      <>
                        <InputWithLabelSection style={{ minWidth: `400px` }}>
                          <CommonFlex>
                            <CommonFlex
                              gap="10px"
                              margin="0 auto 0 0"
                              style={{ cursor: `pointer` }}
                              onClick={() => setIsWeekViewOfMonth(false)}
                            >
                              <RadioButton active={!isWeekViewOfMonth} />
                              <CommonText paddingLeft="45px" fontWeight="500">
                                Dates of Month
                              </CommonText>
                            </CommonFlex>
                            <CommonFlex
                              gap="10px"
                              margin="0 auto 0 0"
                              style={{ cursor: `pointer` }}
                              onClick={() => setIsWeekViewOfMonth(true)}
                            >
                              <RadioButton active={isWeekViewOfMonth} />
                              <CommonText fontWeight="500">
                                Week Days of Month
                              </CommonText>
                            </CommonFlex>
                          </CommonFlex>
                        </InputWithLabelSection>

                        {!isWeekViewOfMonth ? (
                          <>
                            <CommonFlex>
                              <MonthDateContainer>
                                {[
                                  ...Array.from(
                                    { length: MONTH_TOTAL_DAYS },
                                    (_, idx) => idx + 1,
                                  ),
                                  "Last Day",
                                ].map(value => {
                                  const isLastDay = value === "Last Day";
                                  // Convert numeric value to string for key consistency
                                  const dateKey = isLastDay
                                    ? value
                                    : String(value);
                                  return (
                                    <MonthDateBox
                                      key={value}
                                      active={!!activeMonthDates[dateKey]}
                                      onClick={() => onMonthDateSelect(dateKey)}
                                      spanColumns={
                                        isLastDay
                                          ? LAST_DAY_SPAN_COLUMNS
                                          : undefined
                                      }
                                    >
                                      {isLastDay ? "Last day of Month" : value}
                                    </MonthDateBox>
                                  );
                                })}
                              </MonthDateContainer>
                            </CommonFlex>
                            {saveErrors &&
                              saveErrors["activeMonthDates"] !== undefined &&
                              saveErrors["activeMonthDates"] && (
                                <FormAlert>
                                  {saveErrors["activeMonthDates"]}
                                </FormAlert>
                              )}
                          </>
                        ) : (
                          <>
                            <CommonFlex gap="10px">
                              <CommonGrid gap="10px" columns="35px">
                                <WeekNumberBox>1st</WeekNumberBox>
                                <WeekNumberBox>2nd</WeekNumberBox>
                                <WeekNumberBox>3rd</WeekNumberBox>
                                <WeekNumberBox>4th</WeekNumberBox>
                              </CommonGrid>
                              <MonthDateContainer>
                                {activeMonthDays &&
                                  Object.keys(activeMonthDays).length > 0 &&
                                  Object.keys(activeMonthDays).map(
                                    (day, index) => (
                                      <MonthDateBox
                                        key={index}
                                        active={activeMonthDays[day]}
                                        onClick={() => onMonthDaySelect(day)}
                                      >
                                        {weekDays[day % 7]}
                                      </MonthDateBox>
                                    ),
                                  )}
                              </MonthDateContainer>
                            </CommonFlex>
                            {saveErrors &&
                              saveErrors["activeMonthDays"] !== undefined &&
                              saveErrors["activeMonthDays"] && (
                                <FormAlert>
                                  {saveErrors["activeMonthDays"]}
                                </FormAlert>
                              )}
                          </>
                        )}
                      </>
                    )}

                  {scheduleDescription &&
                    selectedRepeatType &&
                    (selectedRepeatType.value === "custom_weekly" ||
                      selectedRepeatType.value === "custom_monthly") && (
                      <ScheduleText>*{scheduleDescription}</ScheduleText>
                    )}

                  <InputWithLabelSection>
                    <InputLabel>
                      {t("ending_on")} <RedStar>*</RedStar>
                    </InputLabel>
                    <DatePicker
                      dateDisplayFormat="DD/MM/YYYY"
                      placeholder="Select End Date"
                      date={endDate ? endDate : null}
                      onDateChange={onEndDateSelect}
                      disablePreviousDatesFrom={startDate}
                      error={
                        saveErrors &&
                        saveErrors["endDate"] !== undefined &&
                        saveErrors["endDate"] &&
                        saveErrors["endDate"]
                      }
                    />
                    {saveErrors &&
                      saveErrors["endDate"] !== undefined &&
                      saveErrors["endDate"] && (
                        <FormAlert>{saveErrors["endDate"]}</FormAlert>
                      )}
                  </InputWithLabelSection>
                </RepeatSection>
              )}
            </div>

            <InputWithLabelSection margin="25px 0 0 0">
              <InputLabel>{t("choose_theme")}</InputLabel>
              <ThemesContainer>
                <ThemeColorComp color="#D4F4EE" />
                <ThemeColorComp color="#D2E4FE" />
                <ThemeColorComp color="#D9D7FC" />
                <ThemeColorComp color="#FDF3E4" />
              </ThemesContainer>
            </InputWithLabelSection>
            <CommonGrid
              columns="auto"
              margin="25px 0 0 0"
              justifyContent="start"
            >
              <CommonFlex gap="12px">
                <WhiteButton
                  width="140px"
                  type="cancel"
                  onClick={() => handleFinish()}
                >
                  {t("cancel")}
                </WhiteButton>
                <PrimaryButton
                  width="140px"
                  disabled={
                    !editType ||
                    !title.trim() ||
                    selectedAssignees.length === 0 ||
                    !startTime ||
                    !endTime ||
                    (editType === "future" && (!selectedRepeatType || !endDate))
                  }
                  onClick={() => handleSave()}
                >
                  {editIsLoading ? (
                    <ButtonTextLoader
                      loadingText={t("saving")}
                      fontSize="13px"
                    />
                  ) : (
                    t("edit_shift")
                  )}
                </PrimaryButton>
              </CommonFlex>
            </CommonGrid>
          </>
        )}
      </ModalBody>
    </Modal>
  );
};

export default EditShift;
